import { render, staticRenderFns } from "./payList.vue?vue&type=template&id=30588a0b&scoped=true&"
import script from "./payList.vue?vue&type=script&lang=js&"
export * from "./payList.vue?vue&type=script&lang=js&"
import style0 from "./payList.vue?vue&type=style&index=0&id=30588a0b&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "30588a0b",
  null
  
)

export default component.exports